import type { AdStudioTemplatesQuery } from "src/graphql";
import {
  type AdStudioTemplateCard,
  type AdStudioTemplateDraft,
  isAdStudioTemplateCard,
  isAdStudioTemplateDraft,
} from "src/pages/ad-studio/templates/types";

export function isUnpublishedAdStudioTemplate(
  template: AdStudioTemplatesQuery["getCurrentAgenticSettingsEntities"][number],
): template is AdStudioTemplateCard | AdStudioTemplateDraft {
  return (
    isAdStudioTemplateDraft(template) ||
    (isAdStudioTemplateCard(template) && template.content.status === "draft")
  );
}
